import * as React from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import Select from 'react-select'


// COMPONENTS
const DropdownContainer = styled.div`
  position: relative;
  max-width: 100%;
  display: flex;
  flex-direction: column;
`
const StyledLabel = styled.label`
  font-weight: 500;
  margin: 4px;
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
`
const Error = styled.div`
  color: red;
`

// custom select styles
const customStyles = {
  control: (styles, props) => {
    return {
      ...styles,
      padding: '0 16px',
      borderRadius: '20px',
      height: '56px',
      border: props.isFocused ? '1px solid black' : '1px solid #bababa',
      boxShadow: 'none',
      cursor: 'pointer',
      ':hover': {
        border: props.isFocused ? '1px solid black' : '1px solid #bababa',
      },
    }
  },
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,

      transition: 'all 0.2s',
      backgroundColor: isSelected ? '#f2fca1' : 'inherit',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      color: 'black',
      ':hover': {
        backgroundColor: '#f2fca1',
      },
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? '#f2fca1' : '#f2fca1'),
      },
      borderRadius: '20px',
    }
  },
  menu: styles => {
    return {
      ...styles,
      borderRadius: '20px',
      margin: 0,
    }
  },
  indicatorSeparator: () => ({
    display: 'none',
  }),
  placeholder: styles => ({
    ...styles,
    color: '#bababa',
  }),
}

const Dropdown = ({
  placeholder,
  onSelect,
  options,
  keepValue,
  label,
  id,
  value,
  error,
  appendIcon,
  tooltiptext,
  containerCss,
  ...rest
}) => {
  const [inputValue, setInputValue] = useState('')
  const staticValue = keepValue ? {} : { value: [] }
  return (
    <DropdownContainer css={containerCss}>
      {label && !appendIcon && <StyledLabel htmlFor={id}>{label}</StyledLabel>}
      {label && appendIcon && (
        <StyledLabel htmlFor={id} >
          {label}
          <div data-tooltip={tooltiptext} className="tooltip">
            <img
              src={appendIcon}
              alt="Icon"
              layout="constrained"
              placeholder="tracedSVG"
            />
          </div>
        </StyledLabel>
      )}
      <Select
        value={value}
        styles={customStyles}
        placeholder={placeholder}
        inputPlaceholder={placeholder}
        onChange={onSelect}
        options={options}
      />
      {error && <Error>{error}</Error>}
    </DropdownContainer>
  )
}

export default Dropdown
